import { render, staticRenderFns } from "./painter.vue?vue&type=template&id=42315062&scoped=true&"
import script from "./painter.vue?vue&type=script&lang=js&"
export * from "./painter.vue?vue&type=script&lang=js&"
import style0 from "./painter.vue?vue&type=style&index=0&id=42315062&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42315062",
  null
  
)

export default component.exports